import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { useContentStore } from '@/stores/content.store'
import { getMediaById, normalizeMedia } from '@/utils/media'

export function useMedia(
  mediaId?: number | null,
  opts?: { imageSize?: string },
) {
  const contentStore = useContentStore()
  const { attachments } = storeToRefs(contentStore)

  const media = computed(() =>
    normalizeMedia(
      getMediaById(attachments.value, mediaId),
      opts?.imageSize ?? 'full',
    ),
  )

  return {
    media,
  }
}
